import React,{useState,useEffect} from "react";
import {Button,notification,Row,Col,Modal, Form, Input} from "antd";
import axios from 'util/Api'
import config from "../util/ApiforContext"
import ClientCaptcha from "react-client-captcha"
import Screen from '../util/Extensions/Screens'
import ReCAPTCHA from "react-google-recaptcha";

const FormItem = Form.Item;

const ForgotPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [captchaCode, setCaptchaCode] = useState("");
  const [smsValue, setSmsValue] = useState("");
  const [captchaKey, setCaptchaKey] = useState(0);
  const [smsPassword, setSmsPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const {initialMinute = 0} = props;
  const [ minutes, setMinutes ] = useState(initialMinute);
  const [seconds, setSeconds ] =  useState(180);
  const [errorText, setErrorText ] =  useState("");
  const [userPassword, setUserPassword] = useState("");
  const [email, setEmail] = useState("");
  const [recaptchaToken, setRecaptchaToken ] =  useState("");

  const [loadingBtn, setLoadingBtn] = useState(false);
  const recaptchaRef = React.createRef();

  const onFinishFailed = errorInfo => {
  };
  const [form] = Form.useForm();
  const handleCancel = () => {
    if(handleCancel){
      setLoading(false)
    }
    setVisible(false)
    setLoadingBtn(false)
  };
  const showModal = () => {
    setSeconds(180)
    setErrorText("")
    setVisible(true)
  }
  useEffect(()=>{
    let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                  handleCancel()
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            } 
        }, 1000)
        return ()=> {
            clearInterval(myInterval);
          };
    });
  const setCode = captchaCode => {
    setCaptchaCode(captchaCode)
  }
  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre yenileme linkiniz mail adresinize gönderilmiştir.',
        duration: 2,
    });
  };
  const openNotificationWithIconWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifre gönderimi sırasında bir hata oluştu.',
        duration: 2,
    });
  };
  const captchaError = type => {
    notification[type]({
      message: 'Hata',
      description:
        'Girilen kod hatalı, tekrar deneyiniz.',
        duration: 5,
    });
  };
  const errorListNotification = type => {
    errorList.map((item)=> {
      notification[type]({
        message: 'Hata',
        description:
        item
         ,
          duration: 2,
      });
    })
  };
  const errorList = [];
  function onChange(value) {
    setRecaptchaToken(value);
  }
  const onFinish = values => {
    setEmail(values.email)
    setLoading(true)
    
    axios.post(`${config.apiUrl}/Auth/GetPsrWithMail`,{
      Email: values.email,
      RecaptchaToken: recaptchaToken
    },config.headers)
    .then(resp => {
      if(resp.data){
        setUserPassword(values.password)
        showModal()
      }else{
        window.location.reload();
      }
    }).catch(
      error => {
        if(error.response.status === 406){
          error.response.data.data.map((item)=>{
            errorList.push(item);
          })
          errorListNotification('error')
          setLoading(false)
          setLoadingBtn(false)
          handleCancel()
          setCaptchaKey(captchaKey + 1)
          window.grecaptcha.reset();
          setRecaptchaToken("");

        }else{
          openNotificationWithIconWarning('error')}
          setLoading(false)
          setLoadingBtn(false)
          setCaptchaKey(captchaKey + 1)
          window.grecaptcha.reset();
          setRecaptchaToken("");
         }
  );;
   
  };

  const handleSubmit = (values) => {
    if(values.Sms === undefined || values.Sms === ""){
      setErrorText("*Lütfen giriş yapınız.")
      setLoadingBtn(false)
      setCaptchaKey(captchaKey + 1)
    }else{
      axios.post(`${config.apiUrl}/Auth/GetPsrWithMail`,{
        SecurityKey: values.Sms,
        Email: email,
        ScreenOption : Screen.screen,
        IsForgotPassword:true,
      },config.headers)
      .then(resp => {
        if(resp.data){
            setLoadingBtn(true)
            openNotificationWithIcon('success');
            setCaptchaKey(captchaKey + 1)
            setTimeout(function () {
            props.history.push('/');
            }.bind(this), 2000);
        }else{
          window.location.reload();
        }
      }).catch(
        error => {
          if(error.response.status === 406){
            error.response.data.data.map((item)=>{
              errorList.push(item);
            })
            errorListNotification('error')
            setLoading(false)
            setLoadingBtn(false)
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
  
          }else{
            openNotificationWithIconWarning('error')}
            setLoading(false)
            setLoadingBtn(false)
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }
    );
      setSmsValue(values.Sms)
    }
   
  }
  function onSubmits() {
    const recaptchaValue = recaptchaRef.current.getValue();
    props.onSubmit(recaptchaValue);
  }
  return (
    <div className="gx-login-container" style={{backgroundColor:'#f0f8ff'}}>
      <div className="gx-login-content">

        <div className="gx-login-header">
            <img src={require("assets/images/AkodeRed.png")} alt="paratic" title="paratic" style={{width:'40%'}}/>
        </div>
        <div className="gx-mb-4">
          <h3>Şifreni mi unuttun ?</h3>
          <p>Mail adresinizi yazdığnız takdirde şifrenizi yenilemeniz için bir link gönderilecektir.</p>
        </div>

        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <FormItem name="email" rules={[{ required: true, message: 'Lütfen mail adresinizi girin!' }]}>
              <Input 
              onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
              autoComplete="off"
              className='gx-input-lineheight' type="email" placeholder="Email adresinizi girin"/>
          </FormItem>
        

          <form onSubmit={onSubmits} >
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LfX1CIdAAAAAC9TS6J53DDfVYb4Xnn7gWJSWCdd"
            type={"image"}
            hl={"tr"}
            style={{marginLeft:20,marginBottom:20}}
            onChange={onChange}
          />
          </form>


          <FormItem>
            <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
              GÖNDER
            </Button>
          </FormItem>
        </Form>
        <Modal 
      visible={visible} onOk={form.submit} okButtonProps={{hidden:true}} cancelButtonProps={{hidden:true}} footer={null} onCancel={handleCancel}>
      <p style={{marginTop:10,textAlign:'center',fontSize:16}}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>
     
      <Form
                   onFinish={handleSubmit}
                    >
               
                <Row style={{marginBottom: -25,marginLeft:32}}>
               
                <Col span={15}>
                <Form.Item
                name="Sms"
                >
                <Input
                onKeyPress={(e) => { (e.key === 'e' || e.key === "E") && e.preventDefault(); }}
                onChange={() => { setErrorText("")}} type='number'/>
                </Form.Item>  
                </Col>
                <Col span={6}>
                <Form.Item  >
                <Button type="primary" htmlType="submit" onClick={() => setLoadingBtn(true)} loading={loadingBtn}>
                    Onayla
                </Button>
                </Form.Item>
                </Col>
                <Col span={3}></Col>
                </Row>
              </Form>
              <p style={{color:'darkred',textAlign:'center',fontWeight:600}}>{errorText}</p>
      </Modal>
      </div>
    </div>
  );
}

export default ForgotPassword
